import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import { computed, ref } from "@vue/composition-api";
import { useVuelidate } from "@vuelidate/core";
import { withValidDate, isAdult, validPhoneNumber, validPhoneNumberWithExt, withValidSin, requiredSin } from "@Shared/@Utils/validation-rules";
import { email as emailValidation } from "vuelidate/lib/validators";
import { applicantBindingsAndVisibilities } from "../pages/applicants/applicantBindingsAndVisibilities";
import { getValidationRulesFromMap } from "@Client/@Composables/application-standalone/validations/getValidationRulesFromMap";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { useApplicantHelpers } from "../pages/applicants/useApplicantHelpers";
import { camelCase, mapKeys } from "lodash";
export const applicantValidator = (applicantIndex, {
  lazy = false
} = {}) => {
  const {
    bindings
  } = applicantBindingsAndVisibilities(applicantIndex, ref("0"));
  const {
    salutation,
    firstName,
    middleName,
    lastName,
    email,
    phoneNumber,
    altPhoneNumber,
    workPhone,
    firstTimeHomeBuyer,
    maritalStatus,
    sin,
    dateOfBirth,
    numChildren,
    languagePreference,
    own,
    monthlyRent,
    coApplicantType,
    relationshipToMainApplicant,
    addresses
  } = bindings;
  const applicantPrefix = computed(() => {
    return applicantIndex.value ? "applicant" : "";
  });
  const {
    GET_SCHEMA_RULES_BY_PATH,
    HAS_CONSOLIDATED_REQUEST
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH, ApplicationStandaloneGetters.HAS_CONSOLIDATED_REQUEST]);
  const {
    isApplicantVisibleFromFillOut,
    getApplicantIdByIndex
  } = useApplicantHelpers();
  const areRulesVisibleFromFillOut = () => !HAS_CONSOLIDATED_REQUEST.value || isApplicantVisibleFromFillOut(getApplicantIdByIndex(applicantIndex.value));
  const rules = computed(() => {
    return getValidationRulesFromMap(areRulesVisibleFromFillOut, GET_SCHEMA_RULES_BY_PATH, applicantRules, applicantPrefix.value, {
      "co-applicants": applicantIndex.value - 1
    });
  });
  const v$ = useVuelidate(rules, {
    salutation,
    firstName,
    middleName,
    lastName,
    email,
    phoneNumber,
    altPhoneNumber,
    workPhone,
    firstTimeHomeBuyer,
    maritalStatus,
    sin,
    dateOfBirth,
    numChildren,
    languagePreference,
    own,
    monthlyRent,
    coApplicantType,
    relationshipToMainApplicant,
    addresses
  }, {
    $scope: true,
    $lazy: lazy
  });
  return {
    v$
  };
};
const applicantRules = {
  salutation: {},
  firstName: {},
  middleName: {},
  lastName: {},
  email: {
    email: () => emailValidation
  },
  phoneNumber: {
    validPhoneNumber: () => validPhoneNumber
  },
  altPhoneNumber: {
    validPhoneNumber: () => validPhoneNumber
  },
  workPhone: {
    validPhoneNumberWithExt: () => validPhoneNumberWithExt
  },
  firstTimeHomeBuyer: {},
  maritalStatus: {},
  sin: {
    requiredSin: () => requiredSin,
    withValidSin: () => withValidSin
  },
  dateOfBirth: {
    isAdult: () => isAdult,
    withValidDate: () => withValidDate
  },
  numChildren: {},
  languagePreference: {},
  own: {},
  monthlyRent: {},
  coApplicantType: {},
  relationshipToMainApplicant: {}
};
export const applicantsValidator = ({
  lazy = true
} = {}) => {
  const {
    allApplicants: applicants
  } = useApplicantHelpers();
  const {
    GET_SCHEMA_RULES_BY_PATH,
    HAS_CONSOLIDATED_REQUEST
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH, ApplicationStandaloneGetters.HAS_CONSOLIDATED_REQUEST]);
  const {
    isApplicantVisibleFromFillOut
  } = useApplicantHelpers();
  const areRulesVisibleFromFillOut = ({
    id,
    applicantId
  }) => !HAS_CONSOLIDATED_REQUEST.value || isApplicantVisibleFromFillOut(id || applicantId);
  const allApplicants = computed(() => {
    var _applicants$value;
    const mappedKeys = (_applicants$value = applicants.value) == null ? void 0 : _flatMapInstanceProperty(_applicants$value).call(_applicants$value, item => areRulesVisibleFromFillOut(item) ? [_objectSpread({
      isMainApplicant: item == null ? void 0 : item.isMainApplicant,
      index: item.index
    }, mapKeys(item["personal-details"], (_value, key) => camelCase(key)))] : []);
    return mappedKeys;
  });
  const rules = computed(() => {
    var _context;
    const mainpApplicantRules = getValidationRulesFromMap(() => true, GET_SCHEMA_RULES_BY_PATH, applicantRules);
    const coApplicantRules = index => getValidationRulesFromMap(() => true, GET_SCHEMA_RULES_BY_PATH, applicantRules, "applicant", {
      "co-applicants": index
    });
    return _reduceInstanceProperty(_context = allApplicants.value).call(_context, (acc, _applicant, index) => {
      acc[index] = _applicant != null && _applicant.isMainApplicant ? mainpApplicantRules : coApplicantRules(_applicant.index);
      return acc;
    }, {});
  });
  const v$ = useVuelidate(rules, allApplicants, {
    $scope: "applicant",
    $lazy: lazy
  });
  return {
    v$
  };
};